/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-site-section py-5">
            <div className="container pt-lg-5">
                <div className="row g-5">
                    {/* Colonne 1 : À propos / Logo */}
                    <div className="col-lg-4 col-md-6 mb-4 mb-md-0 d-flex flex-column align-items-start">
                        <img src={logo} alt="LAMP" className="footer-logo mb-4" />
                        <p className="text-white opacity-75 mb-4 leading-loose small">
                           
                            Nous sommes LAMP( Lampe À Mes Pieds), une plateforme chrétienne fondée sur la Parole de Dieu, inspirée du Psaume 119:105. Notre mission est de vous influencer à vivre selon la Parole de Dieu.
                        </p>
                        <div className="social-footer-links d-flex gap-3">
                            <a href="https://instagram.com" className="social-circle"><i className="bi bi-instagram"></i></a>
                            <a href="https://facebook.com" className="social-circle"><i className="bi bi-facebook"></i></a>
                            <a href="https://wa.me/yournumber" className="social-circle"><i className="bi bi-whatsapp"></i></a>
                        </div>
                    </div>

                    {/* Colonne 2 : Liens Rapides */}
                    <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
                        <h6 className="text-white fw-bold text-uppercase mb-4 outfit">Navigation</h6>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2"><Link to="/">Accueil</Link></li>
                            <li className="mb-2"><Link to="/qui-sommes-nous">Qui sommes-nous ?</Link></li>
                            <li className="mb-2"><Link to="/nos-meditations">Méditations</Link></li>
                            <li className="mb-2"><Link to="/contact">Contact</Link></li>
                        </ul>
                    </div>

                    {/* Colonne 3 : Autres Ressources */}
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
                        <h6 className="text-white fw-bold text-uppercase mb-4 outfit">Informations</h6>
                        <ul className="list-unstyled footer-links">
                            <li className="mb-2"><a href="#terms">Donner à la mission</a></li>
                            <li className="mb-2"><a href="#privacy">Devenir Partenaire</a></li>
                            <li className="mb-2"><a href="#cookies">Mentions Légales</a></li>
                            <li className="mb-2"><a href="#help">Signaler un problème</a></li>
                        </ul>
                    </div>

                    {/* Colonne 4 : Newsletter / Contact */}
                    <div className="col-lg-3 col-md-6">
                        <h6 className="text-white fw-bold text-uppercase mb-4 outfit">Contact Direct</h6>
                        <p className="text-white opacity-75 small mb-3">
                            <i className="bi bi-envelope-fill me-2"></i> contact@lamp-edification.org
                        </p>
                        <p className="text-white opacity-75 small mb-4">
                            <i className="bi bi-geo-alt-fill me-2"></i> whatsapp : +41 78 226 59 29
                        </p>
                        <div className="newsletter-box position-relative">
                            <input type="email" placeholder="Votre email" className="form-control-footer w-100 p-2 ps-3 rounded-pill" />
                            <button className="btn-send-footer animate__animated animate__pulse animate__infinite"><i className="bi bi-send-fill"></i></button>
                        </div>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div className="row mt-5 pt-4 border-top border-white border-opacity-10 opacity-75 small text-white">
                    <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                        &copy; {new Date().getFullYear()} LAMP Edification. Tous droits réservés.
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        {/* Mention supprimée à la demande de l'utilisateur */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
